import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import toast from 'react-hot-toast';

export default function BusinessList() {
  const [businesses, setBusinesses] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [subCounty, setSubCounty] = useState('');
  const [ward, setWard] = useState('');
  const [payment, setPayment] = useState('');
  const [subCounties, setSubCounties] = useState([]);
  const [wards, setWards] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/lookups/sub-counties/').then(r => setSubCounties(r.data));
  }, []);

  useEffect(() => {
    if (subCounty) api.get(`/lookups/wards/?sub_county=${subCounty}`).then(r => setWards(r.data));
    else setWards([]);
  }, [subCounty]);

  const fetchData = useCallback(() => {
    const params = new URLSearchParams({ page });
    if (search) params.set('search', search);
    if (subCounty) params.set('sub_county', subCounty);
    if (ward) params.set('ward', ward);
    if (payment) params.set('mode_of_payment', payment);
    api.get(`/businesses/?${params}`).then(r => {
      setBusinesses(r.data.results);
      setCount(r.data.count);
    });
  }, [page, search, subCounty, ward, payment]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this business?')) return;
    await api.delete(`/businesses/${id}/`);
    toast.success('Deleted');
    fetchData();
  };

  const handleExport = () => {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (subCounty) params.set('sub_county', subCounty);
    if (ward) params.set('ward', ward);
    if (payment) params.set('mode_of_payment', payment);
    const token = localStorage.getItem('access_token');
    const url = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/businesses/export/?${params}`;
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.blob())
      .then(blob => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'businesses.csv';
        a.click();
      });
  };

  const totalPages = Math.ceil(count / 25);

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Businesses ({count})</h1>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button className="btn btn-outline" onClick={handleExport}>⬇ Export CSV</button>
          <button className="btn btn-primary" onClick={() => navigate('/businesses/new')}>+ Add Business</button>
        </div>
      </div>

      <div className="filters-bar">
        <input placeholder="Search..." value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} style={{ width: '200px' }} />
        <select value={subCounty} onChange={e => { setSubCounty(e.target.value); setWard(''); setPage(1); }}>
          <option value="">All Sub Counties</option>
          {subCounties.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select value={ward} onChange={e => { setWard(e.target.value); setPage(1); }}>
          <option value="">All Wards</option>
          {wards.map(w => <option key={w} value={w}>{w}</option>)}
        </select>
        <select value={payment} onChange={e => { setPayment(e.target.value); setPage(1); }}>
          <option value="">All Payments</option>
          <option value="CASH">Cash</option>
          <option value="PAYBILL">Paybill</option>
          <option value="BANK">Bank</option>
          <option value="UNSPECIFIED">Unspecified</option>
        </select>
      </div>

      <div className="card" style={{ overflow: 'auto' }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Business Name</th><th>Trader</th><th>Contact</th>
              <th>Market</th><th>Sub County</th><th>Nature</th>
              <th>Amount</th><th>Payment</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {businesses.map(b => (
              <tr key={b.id}>
                <td>{b.business_name || '-'}</td>
                <td>{b.trader_name || '-'}</td>
                <td>{b.contact || '-'}</td>
                <td>{b.market}</td>
                <td>{b.sub_county}</td>
                <td>{b.nature_of_business || '-'}</td>
                <td style={{ textAlign: 'right' }}>{Number(b.amount).toLocaleString()}</td>
                <td>{b.mode_of_payment}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <button className="btn btn-sm btn-outline" onClick={() => navigate(`/businesses/${b.id}/edit`)} style={{ marginRight: '4px' }}>Edit</button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(b.id)}>Del</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {totalPages > 1 && (
          <div className="pagination">
            <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span>Page {page} of {totalPages}</span>
            <button disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        )}
      </div>
    </div>
  );
}
